import { useForm } from "react-hook-form";
import { Task, UpdateTaskRequest } from "../../types/task";
import { useGetTaskByIdQuery, useUpdateTaskMutation, useUpdateTaskStatusMutation } from "../../api/tareas/tareaApi";
import { CircularProgress } from "@mui/joy";
import { useState } from "react";
import { getErrorMessage } from "../../utils/errorHelpers";
import { ErrorMessage } from "../UtilitiesComponents/ErrorMessage";
import { Information } from "./TaskDetails/Information";
import { Description } from "./TaskDetails/Desciption";
import { TitleInput } from "./TaskDetails/TitleInput";
import { ChangeStatusButtons } from "./TaskDetails/ChangeStatusButtons";
import { UpdateTaskInfoButton } from "./TaskDetails/UpdateTaskInfoButton";

interface Props {
    taskId: number;
    showNavButton?: boolean;
}

export function TaskDetail({ taskId }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const { data: task, isLoading, isFetching, isSuccess } = useGetTaskByIdQuery(taskId);
    const [changeTaskStatus, { isLoading: changeStatusIsLoading }] = useUpdateTaskStatusMutation();
    const [updateTask, { isLoading: updateTaskLoading }] = useUpdateTaskMutation();

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { isDirty }
    } = useForm<Task>({
        values: task,
        resetOptions: {
            keepDirtyValues: true,
        }
    });

    const showRecordatorioTimes = watch("recordatorioActivado", false);

    const submitTaskUpdate = handleSubmit(async (data: Task) => {
        try {
            setErrorMessage(null);

            const request: UpdateTaskRequest = {
                id: taskId,
                titulo: data.titulo,
                texto: data.descripcion,
                recordatorioActivado: data.recordatorioActivado,
            };

            if(!data.recordatorioActivado)
            {
                request.timeBeforeSendNotification = ""
                data.timeBeforeSendNotification = ""
            }

            await updateTask(request).unwrap();
            reset(data);
            
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }); 

    const submitChangeStatus = async (status: boolean) => {
        try {
            setErrorMessage(null);

            const request = {
                taskId,
                terminada: status,
            };

            await changeTaskStatus(request).unwrap();
            
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    if(isLoading || isFetching || !isSuccess)
        return (
            <div className="flex justify-center items-center w-full h-[450px]">
                <CircularProgress />
            </div>
        );

    return (
        <div className="h-full">
            <form autoComplete="off" onSubmit={submitTaskUpdate}>

                <div className="my-2 mx-4">
                    <TitleInput
                        task={task}
                        register={register} />

                    <div className="mb-3">
                        <Information
                            task={task}
                            showRecordatorioTimes={showRecordatorioTimes}
                            register={register} />
                    </div>

                    <Description
                        task={task}
                        register={register} />
                </div>

                {errorMessage && (
                    <div className="my-2">
                        <ErrorMessage
                        customMessage>
                            <p className="text-sm">{errorMessage}</p>
                        </ErrorMessage>
                    </div>
                )}

                <div className="flex justify-center my-4 gap-x-2">
                    <ChangeStatusButtons
                        estatus={task.estatus} 
                        isDirty={isDirty} 
                        submitChangeStatus={submitChangeStatus}
                        changeStatusIsLoading={changeStatusIsLoading} />
                    
                    <UpdateTaskInfoButton
                        isDirty={isDirty} 
                        updateTaskLoading={updateTaskLoading} />
                </div>
            </form>
        </div>
    );
}